import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { FocusInnerDot, FocusOuterDot } from './focus-group.styles';

export const Wrapper = styled.div`
    display: flex;
    flex-grow: 1;
    align-self: stretch;
`;

export const Chart = styled.svg`
    color: ${Variables.Colors.n100};

    & ${FocusInnerDot}:not(:first-of-type),
    & ${FocusOuterDot}:not(:first-of-type) {
        opacity: 0;
        display: none;
    }
`;

export const Error = styled.div`
    flex-grow: 1;
`;
